export const getUniqueGeozoneIds = (coords) => {
  if (!coords) return [];

  const ids = coords.map((item) => item.geoZoneId).filter((id) => !!id);

  return [...new Set(ids)];
};

export default getUniqueGeozoneIds;
